import { createAuthClient } from "better-auth/react"
import { emailOTPClient } from "better-auth/client/plugins"

const backendUrl =
  import.meta.env.VITE_BACKEND_URL?.trim() ||
  (import.meta.env.DEV ? "http://localhost:3001" : "")

if (!backendUrl) {
  throw new Error("VITE_BACKEND_URL is required for authentication.")
}

export const authClient = createAuthClient({
  baseURL: backendUrl,
  plugins: [emailOTPClient()],
  fetchOptions: {
    credentials: "include",
    // Better Auth supplies its own signal for session checks, so its timeout
    // option alone does not bound those requests. Preserve both abort sources.
    customFetchImpl: (input, init) => {
      const timeout = AbortSignal.timeout(10_000)
      return fetch(input, {
        ...init,
        signal: init?.signal
          ? AbortSignal.any([init.signal, timeout])
          : timeout,
      })
    },
  },
})
